// eslint-disable-next-line import/prefer-default-export
export const GOVERNMENTAL = 'Governmental'
export const isGovernmentalRole = JSON.parse(localStorage.getItem('userData')).role === GOVERNMENTAL

export const AVAILABLE_PERMISSIONS = ['drivers', 'verified-drivers', 'blocked-drivers']
